import React, { useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Row, Col, Button } from "react-bootstrap";
import { ArrowCounterclockwise, Cash } from "react-bootstrap-icons";
import { useSelector, useDispatch } from "react-redux";
import { actions as actionStepTwo, getAccountNo, getContractNo, getName, getPhone, getStore, getEmail, getTotal } from "../../../reducers/StepTwo";
import { actions as actionsPay, getData } from "../../../reducers/StepPay";
import { actions as actionStep } from "../../../reducers/Step";
import MyPaymentForm from "../../SquareSDK";
import { currencyFormatter } from "../../generals/normalizaInput";
import { Alert } from "../../Alerts";
import FAMSA from "../../../config/constants";
import axios from "axios";
import Loading from "../../Loading";
import { getTypePay } from "../../../reducers/TypePayment";
import StepThreeLoan from "./step_three_loan";
import { useEffect } from "react";
import ModalInfoCard from "./popupInfoCard";
import ModalLoan from "./modal_loan";
import { getLang } from '../../../reducers/lang';

const StepThree = ({ handleSubmit }) => {
    const distpatch = useDispatch();
    const intl = useIntl();
    const AccountNo = useSelector(getAccountNo);
    const ContractNo = useSelector(getContractNo);
    const Total = useSelector(getTotal);
    const Phone = useSelector(getPhone);
    const store = useSelector(getStore);
    const email = useSelector(getEmail);
    const type_pay = useSelector(getTypePay);
    const CustomerName = useSelector(getName);
    const DataPay = useSelector(getData);
    const [showList, setShowList] = useState(false);
    const [visibility, setVisibility] = useState("d-none");
    const [loading, setLoading] = useState(false);
    const [loadingbtn, setLoadingBtn] = useState(false);
    const [cardSelect, setCardSelect] = useState(null);
    const [show, setShow] = useState(false);
    const [paramsPay, setParamsPay] = useState(null);
    const [state, setState] = useState(null);
    const [validated, setValidated] = useState(null);
    const [transactionId, setTransactionId] = useState(null);
    const [totalConv, setTotalConv] = useState(parseFloat(Total)+FAMSA.SERVER.TRANSACTION);
    const sLang = useSelector(getLang);

    const handlePayNow = async (event) => {
        event.preventDefault();
        let auxpay = [];
        //console.log("DAtaPay: ", DataPay);
        DataPay.map((value, index) => {
            let amount = parseFloat(0);

            if (value.checkPastDue) { amount += value.PastDueAmt };
            if (value.checkCurrentMon) { amount += value.CurrentDueAmt };
            if (value.checkContractOff) { amount += value.PayOff };
            if (value.checkOther) { amount += parseFloat(value.otherValue) };

            if (value.checkPastDue || value.checkCurrentMon || value.checkContractOff || value.checkOther) {
                auxpay.push({
                    AccountNo: value.AccountNo,
                    ContractId: value.ContractNo,
                    VerificationCode: "",
                    DonwloadPath: "",
                    TransactionId: "",
                    Amount: amount,
                    Phone: Phone,
                    Store: store,
                    Email: email,
                    CardType: "",
                    CustomerName: CustomerName,
                    Transaction: FAMSA.SERVER.TRANSACTION
                });
            }
        });
        setParamsPay({
            SourceId: (type_pay === 1) ? "" : cardSelect?.token,
            Company: (type_pay === 1) ? "FAMSAINC" : "LOANS",
            PaymentDetail: auxpay,
            CardInfo: {
                name: (type_pay === 1) ? state?.name : "",
                number: (type_pay === 1) ? state?.number : "",
                expiry: (type_pay === 1) ? state?.expiry : "",
                cvc: (type_pay === 1) ? state?.cvc : "",
                zipCode: (type_pay === 1) ? state?.cp : "",
                issuer: (type_pay === 1) ? state?.issuer : ""
            },
            Transaction: FAMSA.SERVER.TRANSACTION,
            staffId: FAMSA.GUESS_USER,
            lang: sLang,
            staffType: (FAMSA.GUESS_USER == "SYS") ? "SYS" : "NOSYS",
        });
        if (type_pay === 2) {
            if (cardSelect !== null && cardSelect !== undefined) {
                setShow(true);
            } else {
                Alert("danger", "Error", "You need to select a card, to proceed with the payment");
            }
        } else if (type_pay === 1) {
            setLoadingBtn(true);
            if (state !== null && validated !== null) {
                const { number, name, expiry, cvc, cp } = validated;
                if (number && name && expiry && cvc && cp) {
                    const params = {
                        "newCard": {
                            "name": state.name,
                            "number": state.number.trim(),
                            "expiry": state.expiry,
                            "cvc": state.cvc,
                            "zipCode": state.cp,
                            "issuer" : state.issuer
                        },
                        "account": AccountNo,
                        "store": store,
                        "contract": ContractNo,
                        "company": type_pay === 1 ? "FAMSAINC" : "LOANS"
                    }
                    await AddNewCard(params);
                    //setShow(true);
                } else {
                    Alert("danger", "", intl.formatMessage({ id: "step.field.required" }));
                }
            }
        }
        //distpatch(actionStep.nextPage());        
    }

    const AddNewCard = async (params) => {
        const fullURL = FAMSA.SERVER.SERVER + `/api/AddNewCard`;
        await axios.post(fullURL, params).then((response) => {
            //console.log(response);
            //setLoading(false);
            if (response.data.StatusCode === 200) {
                setCardSelect(response.data.Data[0]);
                //setAddCard(true);
                //CardsInfo();
                setShow(true);
                //setOpen(false);
                //setValidated({number: null, name: null, expiry: null, cvc: null, cp: null});
                //setState({number: "", name: "", expiry: "", cvc: "", cp: "", issuer: "", focused: ""});
                //Alert("success", "", intl.formatMessage({id: "step.add.card"}));
            } else {
                //setAddCard(false);
                Alert("danger", "Error", response.data.Message);
            }
        }).catch(error => {
            //setAddCard(false);
            setLoadingBtn(false);
            if (error.response?.data?.StatusCode !== 500) {
                Alert("danger", "Error", error.response.data.Message);
            } else {
                Alert("danger", "Error", error.response.data.Message);
            }
        });
    };

    const SubmitPayment = async (params) => {
        setLoading(true);
        setShow(false);

        const fullURL = FAMSA.SERVER.SERVER + `/api/ProcessPayment`;
        await axios.post(fullURL, params).then((response) => {
            setLoading(false);
            if (response.data.StatusCode === 0) {
                handleSubmit(response.data.Data);
            } else {
                if (response.data.StatusCode === 6) {
                    handleSubmit(response.data.Data);
                    response.data.Data.map((value, index) => {
                    value.Errors.map((e, i) => {
                        Alert("info", "Information", intl.formatMessage({ id: "step.report.support-01" }));
                    });
                });
                } else {
                    response.data.Data.map((value, index) => {
                        value.Errors.map((e, i) => {
                            Alert("danger", "Error in the contract", e.Message);
                        });
                    });
                }
            }
            console.log("Validar transaction", response.data.Data[0]);
            setTransactionId(response.data.Data[0].TransactionId);
        }).catch(error => {
            setLoading(false);
            console.log("error data: ", error.response.data)
            if(error.response.data.Data.length > 0) {
                setTransactionId(error.response.data.Data[0].TransactionId);
                if (error.response.data.StatusCode === 1) {
                    error.response.data.Data.map((value, index) => {
                        value.Errors.map((e, i) => {
                            Alert("danger", "Error", e.Message);
                        });
                    });
                } else {
                    Alert("danger", "Error", intl.formatMessage({ id: "step.report.support" }));
                }
            } else {
                Alert("danger", "Error", intl.formatMessage({ id: "step.report.support" }));
            }
        });
    };

    const handlePrev = (event) => {
        event.preventDefault();
        distpatch(actionStepTwo.setTotal("0"));
        distpatch(actionStep.prevPage());
    }

    const handleInputCard = (state, validated) => {
        setState(state);
        setValidated(validated);
    }

    const handleAddCard = (value) => {

        setCardSelect(value);
    }

    useEffect(() => {
        (type_pay === 2) ? setVisibility("d-block") : setVisibility("d-block");
    }, [type_pay]);

    useEffect(() => {
        if (show) { setLoadingBtn(false); }
    }, [show]);

    useEffect(() => {
        setTotalConv(parseFloat(Total) + parseFloat(FAMSA.SERVER.TRANSACTION));
    }, []);

    return (
        <>
            {(loading) ?
                <Loading />
                :
                <div>
                    <Row className='justify-content-center mx-2 my-3'>
                        <Col md={{ span: (type_pay === 1) ? 6 : 6 }} sm={{ span: 11 }}>
                            <Row className='justify-content-center my-3'>
                                <h4 className="text-decoration-underline famsa-text-blue fw-bold"><FormattedMessage id="step.three.summary" /></h4>
                            </Row>
                            <div className="famsa-bg-gray">
                                <Row className='justify-content-center fw-bold fs-5'>
                                    <Col className="border-bottom" md={{ span: 6 }} sm={{ span: 6 }}>
                                        <p className="famsa-text-gray"><FormattedMessage id="step.three.account" />: {AccountNo} </p>
                                    </Col>
                                </Row>
                                <Row className='border-bottom mt-3 famsa-text-blue fs-6 mx-1'>
                                    <Col className="text-start">
                                        <p><FormattedMessage id="step.two.contract.number" /> [{ContractNo}] :</p>
                                    </Col>
                                    <Col className="text-end" >
                                        <p>{currencyFormatter({ currency: "USD", value: Total })} </p>
                                    </Col>
                                    {/*(type_pay === 2) ? <>
                                        <Col className="text-start">
                                            <p><FormattedMessage id="step.three.summary.txt.convenience" />:</p>
                                        </Col>
                                        <Col className="text-end">
                                            <p>{currencyFormatter({ currency: "USD", value: FAMSA.SERVER.TRANSACTION })} </p>
                                        </Col>
                                    </> : null*/}
                                </Row>
                                {(type_pay === 2) ? <>
                                    <Row className='border-bottom mt-3 famsa-text-blue fs-6 mx-1'>
                                        <Col className="text-start">
                                            <p><FormattedMessage id="step.three.summary.txt.convenience" />:</p>
                                        </Col>
                                        <Col className="text-end">
                                            <p>{currencyFormatter({ currency: "USD", value: FAMSA.SERVER.TRANSACTION })} </p>
                                        </Col>
                                    </Row>
                                    </> : null}
                                <Row className="mt-3 famsa-text-blue fw-bold fs-5 mx-1">
                                    <Col className="text-start">
                                        <p><FormattedMessage id="step.three.ammount.pay" />:</p>
                                    </Col>
                                    <Col className="text-end">
                                        <p>{currencyFormatter({ currency: "USD", value: (type_pay === 2) ?  totalConv : Total})}</p>
                                    </Col>
                                </Row>
                                {(transactionId !== null && transactionId !== "") ? 
                                <>
                                <Row className='border-bottom mt-3 famsa-text-blue fs-6 mx-1'>
                                    <Col className="text-start">
                                        <p><FormattedMessage id="step.three.transactionId" />:</p>
                                    </Col>
                                    <Col className="text-end">
                                        <p>{transactionId}</p>
                                    </Col>
                                </Row>
                                </>
                                :
                                null}
                            </div>
                        </Col>
                        {(type_pay === 1) ?
                            <Col md={{ span: 8 }} sm={{ span: 11 }}>
                                <Row className='justify-content-center my-3'>
                                    <h4 className="text-decoration-underline famsa-text-blue fw-bold"><FormattedMessage id="step.three.card.information" /></h4>
                                </Row>
                                <Row className='justify-content-center mx-1 my-3'>
                                    <ModalLoan
                                        openAccordion={true}
                                        handleInputCard={handleInputCard} />
                                </Row>
                            </Col>
                            : null}
                    </Row>
                    {(type_pay === 2) ? <StepThreeLoan handleAddCard={handleAddCard} /> : null}
                    <Row className='justify-content-end mx-1 my-3'>
                        <Col className="my-3" md={{ span: 4 }} sm={{ span: 11 }}>
                            <Button className="famsa-btn-gray famsa-btn-w fs-5" onClick={(e) => { handlePrev(e) }}><ArrowCounterclockwise className="me-3" /><FormattedMessage id="step.three.btn.edit.pay" /></Button>
                        </Col>
                        <Col className="my-3" md={{ span: 4 }} sm={{ span: 11 }}>
                            <Button className={`famsa-btn-green famsa-btn-w fs-5 ${visibility}`} onClick={(e) => handlePayNow(e)}>
                                {(loadingbtn) ?
                                    <Loading />
                                    :
                                    <><Cash className="me-3" /><FormattedMessage id="step.three.btn.pay" /></>
                                }
                            </Button>
                        </Col>
                    </Row>
                </div>
            }
            <ModalInfoCard
                show={show}
                handleClose={() => { setShow(false); setLoadingBtn(false); }}
                info={cardSelect}
                handleAcceptPay={async () => { await SubmitPayment(paramsPay) }}
            />
        </>
    );
}

export default StepThree;